// extracted by mini-css-extract-plugin
module.exports = {"componentsMapCard":"styles_componentsMapCard__2UAOQ","merchantName":"styles_merchantName__2yZfC"};